/**
 * Catálogo Higienizado e Tipado de Repositórios GitHub — Morfeu333 (Automatrix)
 * Total de repositórios: 168
 * Categorização em 5 clusters: ai-agents, automation-crm, web-saas, infra-cloud, tools-libraries
 * Descrições institucionais sem exposição de dados sensíveis.
 */

export type RepoCategory =
  | 'ai-agents'
  | 'automation-crm'
  | 'web-saas'
  | 'infra-cloud'
  | 'tools-libraries';

export interface GitHubRepo {
  name: string;
  title: string;
  description: string;
  isPrivate: boolean;
  url: string;
  language: string;
  stars: number;
  category: RepoCategory;
  tags: string[];
  featured: boolean;
}

export const GITHUB_REPOS: GitHubRepo[] = [
  {
    name: "govi-suite",
    title: "Govi Suite",
    description: "Ecossistema integrado de inteligência operacional, onboarding de clientes e orquestração de fluxos agênticos para negócios.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/govi-suite",
    language: "HTML",
    stars: 0,
    category: "ai-agents",
    tags: ["AI Agents", "Orchestration", "Enterprise", "HTML5"],
    featured: true,
  },
  {
    name: "automatrix-solution-architect",
    title: "Automatrix Solution Architect",
    description: "Configurador interativo e motor de precificação e arquitetura para soluções de automação e inteligência artificial.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-solution-architect",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["Solution Architecture", "Pricing Engine", "AI Automation", "TypeScript"],
    featured: true,
  },
  {
    name: "automatrix-city",
    title: "Automatrix City",
    description: "Digital twin isométrico 3D interativo para visualização de infraestrutura, monitoramento de agentes e telemetria operacional.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-city",
    language: "JavaScript",
    stars: 0,
    category: "web-saas",
    tags: ["Three.js", "WebGL", "Digital Twin", "JavaScript"],
    featured: true,
  },
  {
    name: "cyberdox-intelligence",
    title: "CyberDox Intelligence",
    description: "Plataforma de business intelligence, auditoria forense e validação de evidências com frontend Next.js e backend FastAPI.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/cyberdox-intelligence",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Next.js", "FastAPI", "Forensics", "Business Intelligence"],
    featured: true,
  },
  {
    name: "automatrix-agenda",
    title: "Automatrix Agenda",
    description: "Webapp de onboarding e agendamento arquitetural com React, Vite, Cloudflare Pages/Functions e backend Supabase.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-agenda",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["React", "Vite", "Cloudflare Pages", "Supabase"],
    featured: true,
  },
  {
    name: "automatrix-content-engine",
    title: "Automatrix Content Engine",
    description: "Sistema editorial inteligente com pipelines de criação de roteiros, métricas auditadas e síntese audiovisual.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/automatrix-content-engine",
    language: "HTML",
    stars: 0,
    category: "ai-agents",
    tags: ["Content Generation", "AI Video", "Omni Flow", "Publishing"],
    featured: true,
  },
  {
    name: "agency-os-notion",
    title: "Agency OS Notion",
    description: "Framework agêntico e skill para preenchimento automatizado do Agency OS no Notion com projetos, tarefas e atas de reunião.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/agency-os-notion",
    language: "Python",
    stars: 0,
    category: "automation-crm",
    tags: ["Notion API", "Agency OS", "Automation", "Workflow"],
    featured: true,
  },
  {
    name: "automatrix-studio",
    title: "Automatrix Studio 3D",
    description: "Experiência web interativa 3D de alta performance desenvolvida com Next.js 15, React Three Fiber e Three.js.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/automatrix-studio",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Next.js 15", "React Three Fiber", "Three.js", "Creative Tech"],
    featured: true,
  },
  {
    name: "chatwoot-automatrix",
    title: "Chatwoot Automatrix",
    description: "Hub omnichannel self-hosted integrado com Cloudflare Tunnels, WhatsApp Cloud API, Instagram Login e automações n8n.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/chatwoot-automatrix",
    language: "Ruby",
    stars: 0,
    category: "automation-crm",
    tags: ["Chatwoot", "Docker", "WhatsApp Cloud API", "n8n"],
    featured: true,
  },
  {
    name: "automatrix-mission-control",
    title: "Automatrix Mission Control",
    description: "Painel de operações e motor de automação com agentes autônomos, scrapers, sincronização com Notion e cron jobs.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-mission-control",
    language: "Python",
    stars: 0,
    category: "web-saas",
    tags: ["Mission Control", "Multi-Agent", "Python", "Automation"],
    featured: true,
  },
  {
    name: "openclaw-nerve",
    title: "OpenClaw Nerve Cockpit",
    description: "Cockpit web em tempo real para OpenClaw: orquestração de voz com IA, kanban autônomo, controle de workspace e telemetria.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/openclaw-nerve",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["OpenClaw", "Voice AI", "Real-Time", "Cockpit", "TypeScript"],
    featured: true,
  },
  {
    name: "recrutacis",
    title: "RecrutaCIS Core Platform",
    description: "Plataforma avançada de contratação inteligente com triagem curricular por IA, testes comportamentais e ranking preditivo.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/recrutacis",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["HR Tech", "AI Screening", "Enterprise SaaS", "TypeScript"],
    featured: true,
  },
  {
    name: "automatrix-onboarding-blueprint",
    title: "Automatrix Onboarding Blueprint",
    description: "Especificação técnica e protótipo visual do pipeline de onboarding técnico-comercial para clientes corporativos.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-onboarding-blueprint",
    language: "HTML",
    stars: 0,
    category: "automation-crm",
    tags: ["Onboarding", "CRM", "Sales Pipeline", "UX/UI"],
    featured: false,
  },
  {
    name: "deck-da-villa-automatrix-handoff",
    title: "Deck da Villa Handoff",
    description: "Documentação de arquitetura, fluxos operacionais e handoff técnico da automação para o ecossistema Deck da Villa.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/deck-da-villa-automatrix-handoff",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Handoff", "Hospitality", "Automation", "CRM"],
    featured: false,
  },
  {
    name: "deckvilla-qloapps-deploy",
    title: "Deck da Villa QloApps Deploy",
    description: "Blueprint e scripts de orquestração para deploy isolado do sistema de gestão hoteleira com alta disponibilidade.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/deckvilla-qloapps-deploy",
    language: "Shell",
    stars: 0,
    category: "infra-cloud",
    tags: ["Docker", "Hospitality", "Cloud Deploy", "Infrastructure"],
    featured: false,
  },
  {
    name: "qloapps-render-sandbox",
    title: "QloApps Render Sandbox",
    description: "Ambiente de deploy sandbox conteinerizado para o PMS hoteleiro open-source QloApps com infraestrutura gerenciada.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/qloapps-render-sandbox",
    language: "Shell",
    stars: 0,
    category: "infra-cloud",
    tags: ["Docker", "Render", "PMS", "DevOps"],
    featured: false,
  },
  {
    name: "social-media-ai-gigakit",
    title: "Social Media AI Gigakit",
    description: "Kit de ferramentas e templates de automação de conteúdo com inteligência artificial para mídias sociais.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/social-media-ai-gigakit",
    language: "HTML",
    stars: 0,
    category: "ai-agents",
    tags: ["AI Content", "Social Media", "Generative AI", "Prompts"],
    featured: false,
  },
  {
    name: "ai-trainers-funnel",
    title: "AI Trainers Funnel",
    description: "Funil de conversão e aquisição para formação e credenciamento de especialistas em treinamento de inteligência artificial.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/ai-trainers-funnel",
    language: "HTML",
    stars: 0,
    category: "automation-crm",
    tags: ["Funnel", "Growth", "AI Training", "Landing Page"],
    featured: false,
  },
  {
    name: "antigravity-platform",
    title: "Antigravity Platform",
    description: "Framework e utilitários de extensão para a plataforma de agentes autônomos e ambientes de desenvolvimento assistido por IA.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/antigravity-platform",
    language: "TypeScript",
    stars: 0,
    category: "tools-libraries",
    tags: ["Antigravity", "SDK", "Developer Tools", "AI Runtime"],
    featured: false,
  },
  {
    name: "Morfeu333.github.io",
    title: "Morfeu333 Academic & Tech Portfolio",
    description: "Portal institucional e portfólio acadêmico/tecnológico desenvolvido em Hugo com foco em engenharia e inteligência artificial.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/Morfeu333.github.io",
    language: "HTML",
    stars: 0,
    category: "web-saas",
    tags: ["Hugo", "Portfolio", "Web", "Static Site"],
    featured: false,
  },
  {
    name: "automatrix-xeon-rebuild-2026-09-17",
    title: "Xeon Server Infrastructure Rebuild",
    description: "Automação de provisionamento, scripts de configuração e snapshot de infraestrutura para o servidor bare-metal Xeon.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-xeon-rebuild-2026-09-17",
    language: "Python",
    stars: 0,
    category: "infra-cloud",
    tags: ["Linux", "Ubuntu", "Bare Metal", "Infrastructure as Code"],
    featured: false,
  },
  {
    name: "automatrix-lead-system",
    title: "Automatrix Lead System",
    description: "Sistema de captação e qualificação de leads com agentes OpenClaw, backend reativo Convex e pipeline de CRM.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-lead-system",
    language: "TypeScript",
    stars: 0,
    category: "automation-crm",
    tags: ["Convex", "Lead Scoring", "OpenClaw", "CRM"],
    featured: false,
  },
  {
    name: "automatrix-grok-context",
    title: "Automatrix Context Hub",
    description: "Repositório central de contexto operacional sanitizado, diretrizes de arquitetura e conhecimento para agentes de IA.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-grok-context",
    language: "Shell",
    stars: 0,
    category: "ai-agents",
    tags: ["Context Engineering", "Knowledge Base", "System Prompts", "AI"],
    featured: false,
  },
  {
    name: "instagram-video-analyzer-mcp",
    title: "Instagram Video Analyzer MCP",
    description: "Servidor MCP para download, transcrição e análise aprofundada de vídeos do Instagram com visão computacional e IA.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/instagram-video-analyzer-mcp",
    language: "Python",
    stars: 13,
    category: "ai-agents",
    tags: ["MCP", "Instagram", "Computer Vision", "Python"],
    featured: false,
  },
  {
    name: "openclaw-backup",
    title: "OpenClaw Backup & State Sync",
    description: "Mecanismo de sincronização e backup de workspaces, estados de sessão e histórico operacional do OpenClaw.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/openclaw-backup",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["OpenClaw", "State Sync", "Backup", "TypeScript"],
    featured: false,
  },
  {
    name: "vistoria-app",
    title: "Vistoria App",
    description: "Plataforma self-service de vistoria veicular com análise de imagens por visão computacional, Next.js e Supabase.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/vistoria-app",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Next.js", "Computer Vision", "Supabase", "OpenAI"],
    featured: false,
  },
  {
    name: "moti-featured-pros",
    title: "MOTI Featured Pros",
    description: "Landing page de alta conversão e gerador de anúncios programáticos em vídeo (HTML5 + Remotion) para motiapp.com.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/moti-featured-pros",
    language: "HTML",
    stars: 0,
    category: "web-saas",
    tags: ["Remotion", "Video Automation", "Landing Page", "HTML5"],
    featured: false,
  },
  {
    name: "coding-agent-security-checklist",
    title: "Coding Agent Security Checklist",
    description: "Guia de segurança e hardening para agentes de código autônomos contra ataques de injeção de prompt e supply chain.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/coding-agent-security-checklist",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["Cybersecurity", "Agent Security", "Hardening", "Policy"],
    featured: false,
  },
  {
    name: "gestao-imobiliaria-leonam",
    title: "Gestão Imobiliária Leonam",
    description: "Plano operacional e infraestrutura de CRM GoHighLevel integrada a agentes de atendimento para o setor imobiliário.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/gestao-imobiliaria-leonam",
    language: "JavaScript",
    stars: 0,
    category: "automation-crm",
    tags: ["GoHighLevel", "Real Estate", "WhatsApp", "AI SDR"],
    featured: false,
  },
  {
    name: "automatrix-agents",
    title: "Automatrix Multi-Agent Swarm",
    description: "Conjunto de agentes autônomos OpenClaw para scraping qualificado, gestão de projetos e rastreamento de métricas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-agents",
    language: "HTML",
    stars: 0,
    category: "ai-agents",
    tags: ["Multi-Agent", "OpenClaw", "Autonomous Agents", "Evals"],
    featured: false,
  },
  {
    name: "mba-ghl-bridge",
    title: "MBA GoHighLevel Bridge",
    description: "Microsserviço de sincronização bidirecional entre sistemas acadêmicos/educacionais e a plataforma GoHighLevel.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/mba-ghl-bridge",
    language: "JavaScript",
    stars: 0,
    category: "automation-crm",
    tags: ["GoHighLevel", "Webhook Bridge", "API Integration", "Node.js"],
    featured: false,
  },
  {
    name: "GHL-Automatrix",
    title: "GHL Automatrix Stack",
    description: "Mapeamento arquitetural, documentação de workflows avançados e esteiras operacionais do ecossistema GoHighLevel.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/GHL-Automatrix",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["GoHighLevel", "Workflows", "Sales Automation", "CRM"],
    featured: false,
  },
  {
    name: "ghl-session-token-keepalive",
    title: "GHL Session Keepalive",
    description: "Utilitário resiliente para rotação programada, persistência e monitoramento de tokens de sessão da API GoHighLevel.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/ghl-session-token-keepalive",
    language: "Shell",
    stars: 0,
    category: "automation-crm",
    tags: ["Token Auth", "Keepalive", "Automation", "Security"],
    featured: false,
  },
  {
    name: "infra-city-sentinela-77seg",
    title: "Infra-City Sentinela 77seg",
    description: "Digital twin 3D em Three.js para telemetria em tempo real e monitoramento operacional de clusters de servidores.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/infra-city-sentinela-77seg",
    language: "HTML",
    stars: 0,
    category: "infra-cloud",
    tags: ["Three.js", "Monitoring", "Digital Twin", "DevOps"],
    featured: false,
  },
  {
    name: "candidatos-fb-scraper",
    title: "Candidatos Lead Scraper",
    description: "Pipeline automatizado de coleta e enriquecimento de dados públicos para atração e seleção de talentos.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/candidatos-fb-scraper",
    language: "HTML",
    stars: 0,
    category: "automation-crm",
    tags: ["Scraping", "Data Pipeline", "Lead Generation", "Automation"],
    featured: false,
  },
  {
    name: "77seg-fleet-spreadsheet-agent",
    title: "77seg Fleet Spreadsheet Agent",
    description: "Agente autônomo com validação em tempo real e autocorreção de planilhas de gestão de frotas e apólices.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/77seg-fleet-spreadsheet-agent",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["AI Agents", "Data Validation", "Python", "Automation"],
    featured: false,
  },
  {
    name: "reel-avatar-remake",
    title: "Reel Avatar Remake",
    description: "Pipeline automatizado para recriação de vídeos curtos com avatares de IA, sincronização labial e edição precisa via CLI.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/reel-avatar-remake",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["AI Video", "HeyGen", "AssemblyAI", "FFmpeg"],
    featured: false,
  },
  {
    name: "opengym",
    title: "OpenGym",
    description: "Plataforma self-hosted para planejamento de treinos, registro biométrico e acompanhamento físico com autenticação por passkey.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/opengym",
    language: "JavaScript",
    stars: 0,
    category: "web-saas",
    tags: ["Self-Hosted", "HealthTech", "JavaScript", "Passkey"],
    featured: false,
  },
  {
    name: "codex-vps-bridge",
    title: "Codex VPS Bridge",
    description: "Ponte segura de comunicação e execução remota para agentes de codificação em instâncias de nuvem isoladas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/codex-vps-bridge",
    language: "TypeScript",
    stars: 0,
    category: "infra-cloud",
    tags: ["VPS", "Remote Execution", "Codex", "Tunnel"],
    featured: false,
  },
  {
    name: "colibri-nvidia-video-production",
    title: "Colibri NVIDIA Video Pipeline",
    description: "Ambiente de renderização e processamento acelerado por hardware NVIDIA para fluxos audiovisuais e pipelines de IA.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/colibri-nvidia-video-production",
    language: "Python",
    stars: 0,
    category: "tools-libraries",
    tags: ["NVIDIA", "GPU Acceleration", "Video Processing", "AI Pipeline"],
    featured: false,
  },
  {
    name: "automatrix-meeting-intelligence",
    title: "Automatrix Meeting Intelligence",
    description: "Pipeline de transcrição inteligente, sumarização executiva e extração de planos de ação a partir de reuniões em vídeo.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-meeting-intelligence",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["Meeting AI", "Transcription", "Executive Summary", "Audio Analysis"],
    featured: false,
  },
  {
    name: "devtrip-ios",
    title: "DevTrip iOS App",
    description: "Aplicativo nativo iOS em SwiftUI com motor de compressão on-device de vídeo para transmissão eficiente em redes móveis.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/devtrip-ios",
    language: "Swift",
    stars: 0,
    category: "tools-libraries",
    tags: ["SwiftUI", "iOS", "Video Compression", "Mobile"],
    featured: false,
  },
  {
    name: "2026-08-22-alessandro-gatti-onboarding-analysis",
    title: "Onboarding Architecture Analysis - Alessandro Gatti",
    description: "Análise técnica executiva, mapeamento de processos e especificação de arquitetura de automação comercial.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-08-22-alessandro-gatti-onboarding-analysis",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Architecture", "Client Onboarding", "CRM", "Walkthrough"],
    featured: false,
  },
  {
    name: "devtrip-app",
    title: "DevTrip Web Platform",
    description: "Plataforma web de gerenciamento e visualização de trajetos e arquivos multimídia com interface moderna.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/devtrip-app",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["React", "TypeScript", "Multimedia", "Cloud Platform"],
    featured: false,
  },
  {
    name: "retake",
    title: "Retake Video Compressor",
    description: "Motor de compressão e otimização de vídeo para ecossistema iOS com processamento em hardware nativo.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/retake",
    language: "Swift",
    stars: 0,
    category: "tools-libraries",
    tags: ["Swift", "AVFoundation", "Compression", "iOS Native"],
    featured: false,
  },
  {
    name: "animation-movie-3d-assets",
    title: "3D Animation Movie Assets",
    description: "Biblioteca estruturada de referências visuais, malhas e texturas para produção de filmes de animação 3D.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/animation-movie-3d-assets",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["3D Animation", "CGI", "Asset Pipeline", "Blender"],
    featured: false,
  },
  {
    name: "Morfeu333",
    title: "GitHub Profile Readme & Ecosystem",
    description: "Perfil profissional do GitHub apresentando métricas, stacks tecnológicas e projetos de inteligência artificial.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/Morfeu333",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["GitHub Profile", "Markdown", "Developer Experience", "Overview"],
    featured: false,
  },
  {
    name: "automatrix-leadgen-docs",
    title: "Automatrix LeadGen Documentation",
    description: "Documentação arquitetural da esteira de aquisição de leads corporativos, fluxos de qualificação e scoring.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-leadgen-docs",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["LeadGen", "Documentation", "Sales Automation", "CRM"],
    featured: false,
  },
  {
    name: "2026-08-12-call-mauricio-77seg-bvix-ubs-caeno-walkthrough",
    title: "Architecture Walkthrough - 77Seg & BVIX",
    description: "Walkthrough técnico com frames sincronizados e transcrição sobre a arquitetura de apólices e vistoria digital.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-08-12-call-mauricio-77seg-bvix-ubs-caeno-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Architecture", "Walkthrough", "InsurTech", "Video Analysis"],
    featured: false,
  },
  {
    name: "remotion-skills",
    title: "Remotion Skills & Video Components",
    description: "Coleção de componentes reutilizáveis e utilitários programáticos para geração de vídeo com código via Remotion.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/remotion-skills",
    language: "TypeScript",
    stars: 0,
    category: "tools-libraries",
    tags: ["Remotion", "React", "Video Generation", "Programmatic Video"],
    featured: false,
  },
  {
    name: "call-edicao-0805-trecho",
    title: "Editorial Master Walkthrough",
    description: "Documentação e transcrição sincronizada de sessões de pós-produção audiovisual e diretrizes de corte.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/call-edicao-0805-trecho",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["Video Editing", "Post-Production", "Transcription", "Walkthrough"],
    featured: false,
  },
  {
    name: "call-thiago-apresentacoes-0805",
    title: "Commercial Architecture Presentation",
    description: "Apresentação e alinhamento de escopo arquitetural para esteiras de automação de vendas e atendimento omnichannel.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/call-thiago-apresentacoes-0805",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Presentation", "Sales Architecture", "CRM", "Walkthrough"],
    featured: false,
  },
  {
    name: "jav-n8n-workflows-guide",
    title: "JAV n8n Workflows Guide",
    description: "Guia visual completo dos 27 workflows do n8n integrando Salesforce, Chatwoot e síntese de voz ElevenLabs.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/jav-n8n-workflows-guide",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["n8n", "Salesforce", "Chatwoot", "ElevenLabs"],
    featured: false,
  },
  {
    name: "silence-retake-editing",
    title: "Silence Retake Editing Pipeline",
    description: "Pipeline automatizado com FFmpeg e AssemblyAI para corte inteligente de silêncio e tomada de regravações com loop de QA.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/silence-retake-editing",
    language: "Python",
    stars: 0,
    category: "tools-libraries",
    tags: ["FFmpeg", "AssemblyAI", "Audio Processing", "Python"],
    featured: false,
  },
  {
    name: "jav-vps-overview",
    title: "JAV VPS Cloud Architecture",
    description: "Mapeamento de infraestrutura, topologia de rede e serviços para a operação de automação empresarial.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/jav-vps-overview",
    language: "Markdown",
    stars: 0,
    category: "infra-cloud",
    tags: ["Cloud Infrastructure", "VPS", "Architecture", "Networking"],
    featured: false,
  },
  {
    name: "capcut-ai-video-intro-recipe",
    title: "CapCut AI Video Intro Recipe",
    description: "Receita reprodutível para introduções em vídeo com IA: legendas dinâmicas, color grading retrô e zoom animado via CLI.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/capcut-ai-video-intro-recipe",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["CapCut", "Video Recipes", "Automation", "Visual Effects"],
    featured: false,
  },
  {
    name: "gemini-scene-analyzer",
    title: "Gemini Scene Analyzer",
    description: "Analisador multimodal de cenas em vídeo com Gemini API, FFmpeg, Cloudinary e SQLite local-first em Next.js.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/gemini-scene-analyzer",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["Gemini API", "Computer Vision", "Video Analysis", "Next.js"],
    featured: false,
  },
  {
    name: "2026-07-13-openclaw-chris-walkthrough",
    title: "OpenClaw Platform Walkthrough - Chris Lamm",
    description: "Demonstração e walkthrough operacional da plataforma OpenClaw com orquestração de agentes para corretores imobiliários.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-07-13-openclaw-chris-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "ai-agents",
    tags: ["OpenClaw", "Mortgage", "AI Agents", "Walkthrough"],
    featured: false,
  },
  {
    name: "2026-07-13-engenharia-de-precos-em-ia-walkthrough",
    title: "Engenharia de Preços em IA Walkthrough",
    description: "Modelagem financeira, arquitetura de custos de inferência de LLMs e estratégias de precificação para agências de IA.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-07-13-engenharia-de-precos-em-ia-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "ai-agents",
    tags: ["AI Economics", "Pricing Architecture", "Token Economics", "Business"],
    featured: false,
  },
  {
    name: "fossflow-infra",
    title: "FossFlow Cloud Infrastructure",
    description: "Configurações de infraestrutura como código para orquestração de microsserviços e workflows escaláveis.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/fossflow-infra",
    language: "TypeScript",
    stars: 0,
    category: "infra-cloud",
    tags: ["IaC", "Cloud Infrastructure", "DevOps", "TypeScript"],
    featured: false,
  },
  {
    name: "2026-07-06-meeting-leonardo-walkthrough",
    title: "WhatsApp & Chatwoot Integration Walkthrough",
    description: "Registro audiovisual e análise de fluxo de integração entre Meta Cloud API, Chatwoot e automação n8n.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-07-06-meeting-leonardo-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Chatwoot", "WhatsApp API", "n8n", "Walkthrough"],
    featured: false,
  },
  {
    name: "lunin-clips-pipeline-handoff",
    title: "Lunin Clips Pipeline Handoff",
    description: "Especificação técnica e handoff de esteira de renderização e corte automatizado de clipes curtos para criadores.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/lunin-clips-pipeline-handoff",
    language: "HTML",
    stars: 0,
    category: "tools-libraries",
    tags: ["Video Automation", "Shorts", "Pipeline", "HTML5"],
    featured: false,
  },
  {
    name: "2026-06-26-sgi-seguros-walkthrough",
    title: "SGI Seguros Data Extraction Walkthrough",
    description: "Demonstração de extração automatizada de dados e emissão de apólices de seguro automotivo integrado ao SGI/SCP-1.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-26-sgi-seguros-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["InsurTech", "Data Extraction", "Automation", "Walkthrough"],
    featured: false,
  },
  {
    name: "2026-06-29-andrea-n8n-shopify-walkthrough",
    title: "Shopify & n8n E-commerce Automation",
    description: "Mapeamento e alinhamento de fluxos automáticos de pedidos, atualizações no WhatsApp e estoque via n8n e Shopify.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-29-andrea-n8n-shopify-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Shopify", "n8n", "WhatsApp", "E-commerce"],
    featured: false,
  },
  {
    name: "sam-moore-proposal",
    title: "GoHighLevel White-Label Proposal",
    description: "Página de proposta interativa com VSL para migração de infraestrutura de CRM e automação de agência.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/sam-moore-proposal",
    language: "HTML",
    stars: 0,
    category: "automation-crm",
    tags: ["GoHighLevel", "Interactive Proposal", "Sales", "HTML5"],
    featured: false,
  },
  {
    name: "77seg-portal",
    title: "77seg Portal",
    description: "Portal corporativo para gestão de apólices, sinistros e vistorias digitais com interface moderna em TypeScript.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/77seg-portal",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["React", "TypeScript", "Insurance", "SaaS"],
    featured: false,
  },
  {
    name: "77seg-prontuario",
    title: "77Seg Prontuário Digital",
    description: "Módulo de prontuário e histórico unificado de clientes e apólices para corretoras de seguros de veículos.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/77seg-prontuario",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["TypeScript", "InsurTech", "CRM", "SaaS"],
    featured: false,
  },
  {
    name: "77seg-core-api",
    title: "77Seg Core API",
    description: "API backend em Python para processamento de cotações, apólices, sinistros e vistorias automotivas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/77seg-core-api",
    language: "Python",
    stars: 0,
    category: "web-saas",
    tags: ["Python", "FastAPI", "API Backend", "InsurTech"],
    featured: false,
  },
  {
    name: "automatrix-onboarding-pipeline",
    title: "Automatrix 12-Step Onboarding Pipeline",
    description: "Pipeline comercial e técnico completo de 12 etapas: matriz de matching, specs de agentes, NDAs e Obsidian Canvas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-onboarding-pipeline",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Onboarding Framework", "Agency Methodology", "Sales", "B2B"],
    featured: false,
  },
  {
    name: "2026-06-18-reuniao-dani-meta-walkthrough",
    title: "Meta Ads & WhatsApp CRM Integration",
    description: "Walkthrough estratégico de integração entre campanhas Meta Ads, webhooks da Cloud API e automação de CRM.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-18-reuniao-dani-meta-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Meta Ads", "WhatsApp API", "CRM", "Walkthrough"],
    featured: false,
  },
  {
    name: "work-exchange-platform-blueprint",
    title: "Work Exchange Platform Blueprint",
    description: "Especificação arquitetural completa no padrão BMAD para marketplace global de intercâmbio e voluntariado.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/work-exchange-platform-blueprint",
    language: "Markdown",
    stars: 0,
    category: "web-saas",
    tags: ["BMAD", "Architecture Blueprint", "Marketplace", "SaaS"],
    featured: false,
  },
  {
    name: "2026-06-16-hvn-aula09-videos-longos-walkthrough",
    title: "HVN Long-Form Video Production Masterclass",
    description: "Documentação e transcrição técnica sobre esteiras de vídeo longo, retenção de audiência e estruturação de roteiro.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/2026-06-16-hvn-aula09-videos-longos-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["Video Production", "Masterclass", "Content Strategy", "Walkthrough"],
    featured: false,
  },
  {
    name: "video-walkthrough",
    title: "Video Walkthrough Pipeline",
    description: "Skill para extração de frames-chave, transcrição em alta precisão com AssemblyAI e publicação de documentação interativa.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/video-walkthrough",
    language: "Shell",
    stars: 0,
    category: "tools-libraries",
    tags: ["AssemblyAI", "FFmpeg", "Documentation", "Video AI"],
    featured: false,
  },
  {
    name: "virallab",
    title: "ViralLab AI Platform",
    description: "Plataforma de inteligência para conteúdo viral com Next.js 15, FastAPI, Supabase e geração automatizada de legendas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/virallab",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Next.js 15", "FastAPI", "Supabase", "Video AI"],
    featured: false,
  },
  {
    name: "proposta-automatrix-gvg",
    title: "Proposta Comercial SDR WhatsApp - GVG",
    description: "Proposta interativa e arquitetura de implantação de agente SDR autônomo sobre a API do WhatsApp Business.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/proposta-automatrix-gvg",
    language: "HTML",
    stars: 0,
    category: "automation-crm",
    tags: ["SDR Agent", "WhatsApp API", "Sales Proposal", "HTML5"],
    featured: false,
  },
  {
    name: "hostinger-sdr-vps",
    title: "SDR Server Infrastructure Guide",
    description: "Documentação técnica de provisionamento, firewall e containers para a VPS de agentes SDR e captação de leads.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/hostinger-sdr-vps",
    language: "Markdown",
    stars: 0,
    category: "infra-cloud",
    tags: ["VPS", "Security", "Docker", "DevOps"],
    featured: false,
  },
  {
    name: "2026-06-10-saulo-sdr-whatsapp-gvg-walkthrough",
    title: "Briefing SDR WhatsApp IA - GVG",
    description: "Walkthrough da reunião de briefing técnico e alinhamento de prompts para o agente SDR de WhatsApp.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-10-saulo-sdr-whatsapp-gvg-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["AI SDR", "Briefing", "WhatsApp", "Walkthrough"],
    featured: false,
  },
  {
    name: "kinbox-mcp",
    title: "Kinbox MCP Server",
    description: "Servidor Model Context Protocol (MCP) para integração de agentes de IA com a API de atendimento Kinbox.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/kinbox-mcp",
    language: "JavaScript",
    stars: 0,
    category: "ai-agents",
    tags: ["MCP", "Kinbox", "Omnichannel", "JavaScript"],
    featured: false,
  },
  {
    name: "2026-06-03-reuniao-walkthrough",
    title: "Executive Planning Walkthrough",
    description: "Registro audiovisual estruturado com transcrição de alta fidelidade e marcos de planejamento de produto.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/2026-06-03-reuniao-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["Planning", "Transcription", "AssemblyAI", "Walkthrough"],
    featured: false,
  },
  {
    name: "animated-presentation-skill",
    title: "Animated Presentation Skill",
    description: "Ferramenta para criação programática de apresentações animadas narradas com sincronia Remotion e design de áudio.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/animated-presentation-skill",
    language: "TypeScript",
    stars: 0,
    category: "tools-libraries",
    tags: ["Remotion", "Voice Sync", "Programmatic Video", "AI Tools"],
    featured: false,
  },
  {
    name: "video-walkthrough-skill",
    title: "Video Walkthrough Generator Skill",
    description: "Pipeline automatizado de gravação de tela: compressão otimizada, transcrição via IA e publicação de páginas interativas.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/video-walkthrough-skill",
    language: "Python",
    stars: 0,
    category: "tools-libraries",
    tags: ["AI Pipeline", "Screen Recording", "Walkthrough", "Documentation"],
    featured: false,
  },
  {
    name: "sentry-vault",
    title: "Sentry Vault Meeting Search",
    description: "Motor de busca semântica sobre gravações de reuniões e áudio com FastAPI, React, sentrysearch e Supabase.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/sentry-vault",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Semantic Search", "FastAPI", "Supabase", "Vector DB"],
    featured: false,
  },
  {
    name: "meeting-library",
    title: "HTML5 Meeting Library",
    description: "Player e biblioteca corporativa em HTML5 com busca indexada e reprodução rápida de gravações de alinhamento técnico.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/meeting-library",
    language: "HTML",
    stars: 0,
    category: "web-saas",
    tags: ["HTML5 Video", "Video Library", "Frontend", "Search"],
    featured: false,
  },
  {
    name: "2026-06-06-chrislamm-studioos-walkthrough",
    title: "Studio OS Demo - Chris Lamm",
    description: "Apresentação e validação técnica da integração entre Studio OS e OpenClaw para automação operacional de corretagem.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-06-chrislamm-studioos-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "ai-agents",
    tags: ["Studio OS", "OpenClaw", "AI Workflow", "Walkthrough"],
    featured: false,
  },
  {
    name: "2026-06-06-agency-os-instrucoes-walkthrough",
    title: "Agency OS Architecture Guide",
    description: "Walkthrough detalhado sobre a governança de projetos, tarefas, contatos e portal do cliente no Agency OS.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-06-agency-os-instrucoes-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Agency OS", "Notion", "Project Management", "Walkthrough"],
    featured: false,
  },
  {
    name: "Reuniao-Organizacao-Arquivos-Automatrix",
    title: "Media Bank & Storage Architecture",
    description: "Estratégia de sincronização de ativos de vídeo e organização de storage entre estações de trabalho e servidor central.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/Reuniao-Organizacao-Arquivos-Automatrix",
    language: "Markdown",
    stars: 0,
    category: "infra-cloud",
    tags: ["Storage Architecture", "File Management", "DevOps", "Media Bank"],
    featured: false,
  },
  {
    name: "2026-06-05-junior-whatsapp2-walkthrough",
    title: "WhatsApp Automotive Operations Walkthrough",
    description: "Análise operacional e desenho de fluxos de mensageria para negociação automotiva com integração CRM.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-05-junior-whatsapp2-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["WhatsApp", "Automotive", "CRM", "Walkthrough"],
    featured: false,
  },
  {
    name: "2026-06-04-worldpackers-walkthrough",
    title: "Worldpackers AI Agents Architecture",
    description: "Análise profunda de produto e modelagem de arquitetura com agentes de IA para plataformas de voluntariado.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/2026-06-04-worldpackers-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "web-saas",
    tags: ["Product Design", "AI Architecture", "SaaS", "Walkthrough"],
    featured: false,
  },
  {
    name: "2026-06-03-reuniao-1333-walkthrough",
    title: "Technical Alignment Session 13:33",
    description: "Transcrição e mapeamento de decisões técnicas sobre integrações de IA e infraestrutura em nuvem.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/2026-06-03-reuniao-1333-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["Technical Alignment", "Transcription", "Walkthrough"],
    featured: false,
  },
  {
    name: "automatrix-dev-setup",
    title: "Automatrix Dev Setup & Skills",
    description: "Configurações de ambiente de desenvolvimento, documentação para colaboradores e skills personalizadas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/automatrix-dev-setup",
    language: "Shell",
    stars: 0,
    category: "infra-cloud",
    tags: ["Dev Environment", "Dotfiles", "Shell Script", "Onboarding"],
    featured: false,
  },
  {
    name: "2026-06-01-automatrix-contexto-walkthrough",
    title: "Automatrix Lead System Architecture",
    description: "Walkthrough arquitetural sobre o pipeline de captação de leads e atuação coordenada de agentes autônomos.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-06-01-automatrix-contexto-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Lead Acquisition", "Agent Swarm", "Architecture", "Walkthrough"],
    featured: false,
  },
  {
    name: "2026-05-30-reuniao-walkthrough",
    title: "Sprint Review Walkthrough",
    description: "Transcrição de revisão de sprint com sincronização de telas e validação de entregáveis de desenvolvimento.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-05-30-reuniao-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["Sprint Review", "Audio Sync", "Walkthrough"],
    featured: false,
  },
  {
    name: "narration-session-edit",
    title: "Narration Session Editor",
    description: "Skill para edição inteligente de sessões de voz com extração automática das melhores tomadas via AssemblyAI e FFmpeg.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/narration-session-edit",
    language: "Python",
    stars: 0,
    category: "tools-libraries",
    tags: ["AssemblyAI", "Voice-Over", "FFmpeg", "Audio Editing"],
    featured: false,
  },
  {
    name: "2026-05-21-bvix-antifraude-walkthrough",
    title: "BVIX Anti-Fraud Testing Walkthrough",
    description: "Testes e validação técnica do algoritmo antifraude e consistência biométrica para vistorias veiculares digitais.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/2026-05-21-bvix-antifraude-walkthrough",
    language: "Shell",
    stars: 0,
    category: "web-saas",
    tags: ["Anti-Fraud", "Computer Vision", "Automotive", "Testing"],
    featured: false,
  },
  {
    name: "bvix-vistoria-audit",
    title: "BVIX Inspection App Audit",
    description: "Auditoria técnica aprofundada e blueprint arquitetural para réplica e modernização de aplicativo de vistoria veicular.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/bvix-vistoria-audit",
    language: "JavaScript",
    stars: 0,
    category: "web-saas",
    tags: ["App Audit", "Reverse Engineering", "InsurTech", "Architecture"],
    featured: false,
  },
  {
    name: "capcut-mcp",
    title: "CapCut MCP Server",
    description: "Servidor MCP avançado para manipulação direta de projetos do CapCut (12 ferramentas tipadas, backup e guards).",
    isPrivate: false,
    url: "https://github.com/Morfeu333/capcut-mcp",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["MCP", "CapCut", "Video Editing", "Python"],
    featured: false,
  },
  {
    name: "news-broll-pipeline",
    title: "News B-Roll Video Pipeline",
    description: "Pipeline end-to-end para geração de vídeos comentados a partir de notícias: transcrição, captura de b-roll e animações.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/news-broll-pipeline",
    language: "HTML",
    stars: 0,
    category: "tools-libraries",
    tags: ["News Video", "B-Roll", "Video Automation", "HTML5"],
    featured: false,
  },
  {
    name: "chrislamm-mac-mini-docs",
    title: "Edge Gateway Infrastructure Guide",
    description: "Documentação operacional do gateway local em Mac Mini: serviços isolados, túneis seguros e integração OpenClaw.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/chrislamm-mac-mini-docs",
    language: "Markdown",
    stars: 0,
    category: "infra-cloud",
    tags: ["Tailscale", "Mac Mini", "Edge Gateway", "Infrastructure"],
    featured: false,
  },
  {
    name: "chrislamm-vps-docs",
    title: "Production VPS Stack Guide",
    description: "Documentação da infraestrutura em nuvem: orquestração de containers Chatwoot, n8n, PostgreSQL e Redis.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/chrislamm-vps-docs",
    language: "Dockerfile",
    stars: 0,
    category: "infra-cloud",
    tags: ["VPS", "Docker", "DevOps", "Production Stack"],
    featured: false,
  },
  {
    name: "chris-lamm-walkthrough-saulo",
    title: "Chris Lamm Architecture Walkthrough",
    description: "Página interativa com transcrição e sincronização de telas sobre a arquitetura da plataforma OpenClaw.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/chris-lamm-walkthrough-saulo",
    language: "HTML",
    stars: 0,
    category: "ai-agents",
    tags: ["Interactive Walkthrough", "OpenClaw", "Mortgage", "HTML5"],
    featured: false,
  },
  {
    name: "2026-05-07-chris-extra-meeting-walkthrough",
    title: "Mortgage Pipeline & n8n Routines Walkthrough",
    description: "Análise técnica de dashboards de pipeline, rotinas n8n e métricas operacionais para corretores de hipotecas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-05-07-chris-extra-meeting-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["n8n", "Mortgage", "Operations", "Walkthrough"],
    featured: false,
  },
  {
    name: "openclaw-skill",
    title: "OpenClaw Skill Package",
    description: "Pacote de habilidades e ferramentas para integração do ecossistema OpenClaw com interfaces de linha de comando.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/openclaw-skill",
    language: "Markdown",
    stars: 0,
    category: "ai-agents",
    tags: ["OpenClaw", "Agent Skill", "CLI", "Automation"],
    featured: false,
  },
  {
    name: "2026-05-02-chris-lamm-studio-os-walkthrough",
    title: "Studio OS & n8n Workflows Review",
    description: "Análise das rotinas de automação no n8n para corretagem imobiliária integradas ao Studio OS.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/2026-05-02-chris-lamm-studio-os-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "ai-agents",
    tags: ["Studio OS", "n8n", "Mortgage", "Walkthrough"],
    featured: false,
  },
  {
    name: "chatwoot-demo-walkthrough",
    title: "Chatwoot Omnichannel Demo",
    description: "Demonstração e configuração de múltiplos canais no Chatwoot: Telegram, Instagram, WhatsApp Cloud e Evolution API.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/chatwoot-demo-walkthrough",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["Chatwoot", "Omnichannel", "WhatsApp", "Demo"],
    featured: false,
  },
  {
    name: "studio-os-docs",
    title: "Studio OS Architecture Docs",
    description: "Especificação da arquitetura do Studio OS: pipeline editorial, geradores de vídeo HeyGen e integração com CRM.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/studio-os-docs",
    language: "Markdown",
    stars: 0,
    category: "ai-agents",
    tags: ["Studio OS", "Architecture", "Video Generation", "CRM"],
    featured: false,
  },
  {
    name: "schmooze-pipeline",
    title: "Schmooze Messaging Bridge",
    description: "Documentação do pipeline de sincronização entre iMessage, Chatwoot e agentes de IA OpenClaw.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/schmooze-pipeline",
    language: "Markdown",
    stars: 0,
    category: "automation-crm",
    tags: ["iMessage", "Chatwoot", "OpenClaw", "Messaging Bridge"],
    featured: false,
  },
  {
    name: "chrislamm-ai-infrastructure",
    title: "Chris Lamm AI Infrastructure",
    description: "Visão técnica e blueprint da plataforma de comunicação inteligente: segurança de rede, modelos e mensageria.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/chrislamm-ai-infrastructure",
    language: "Markdown",
    stars: 0,
    category: "infra-cloud",
    tags: ["Infrastructure", "Security", "AI Communications", "Architecture"],
    featured: false,
  },
  {
    name: "studio-os2",
    title: "Studio OS Core",
    description: "Shell operacional local-first para inteligência de produção, edição audiovisual e publicação para criadores.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/studio-os2",
    language: "JavaScript",
    stars: 0,
    category: "web-saas",
    tags: ["Local-First", "Creative Suite", "JavaScript", "Electron"],
    featured: false,
  },
  {
    name: "mission-control-v2",
    title: "Mission Control Lead Pipeline v2",
    description: "Dashboard executivo em tempo real para monitoramento de leads, banco Convex, caixa de entrada SDR e cron jobs.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/mission-control-v2",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Convex DB", "Lead Management", "Next.js", "TypeScript"],
    featured: false,
  },
  {
    name: "dcb-intake-prototype",
    title: "DCB Intake Prototype",
    description: "Protótipo interativo de intake para construção civil com geração automatizada de orçamentos em PDF.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/dcb-intake-prototype",
    language: "HTML",
    stars: 0,
    category: "web-saas",
    tags: ["Prototype", "PDF Generation", "Construction", "HTML5"],
    featured: false,
  },
  {
    name: "rork-mind-insurance-challenge-app",
    title: "Mind Insurance Challenge App",
    description: "Aplicação móvel para transformação de hábitos e reprogramação comportamental com trilhas estruturadas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/rork-mind-insurance-challenge-app",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["React Native", "Expo", "Behavioral Health", "TypeScript"],
    featured: false,
  },
  {
    name: "DCBJX15",
    title: "DCB Proposal Interactive Interface",
    description: "Interface web de apresentação de contratos e orçamentos para empreendimentos de alta precisão.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/DCBJX15",
    language: "HTML",
    stars: 0,
    category: "web-saas",
    tags: ["Proposal", "Interactive UI", "Construction", "HTML5"],
    featured: false,
  },
  {
    name: "meets-video-pipeline",
    title: "Meets Video AV1 Pipeline",
    description: "Esteira automatizada de compressão AV1 para gravações de reuniões: redução de até 81% com extração de áudio paralela.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/meets-video-pipeline",
    language: "Shell",
    stars: 0,
    category: "tools-libraries",
    tags: ["AV1", "FFmpeg", "Video Compression", "Shell"],
    featured: false,
  },
  {
    name: "dcb-intake-app",
    title: "DCB Intake App",
    description: "Sistema de intake comercial, geração de propostas e gestão de pipeline para a construtora D&C Builders.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/dcb-intake-app",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Next.js", "Construction", "Proposal Engine", "TypeScript"],
    featured: false,
  },
  {
    name: "GupyMCP",
    title: "Gupy MCP Server",
    description: "Servidor MCP em Python para integração com APIs de recrutamento e vagas da plataforma Gupy.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/GupyMCP",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["Gupy", "MCP", "HR Tech", "Python"],
    featured: false,
  },
  {
    name: "mission-control-article",
    title: "Mission Control Case Study",
    description: "Artigo técnico e documentação de arquitetura detalhando o desenvolvimento do painel Mission Control.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/mission-control-article",
    language: "Markdown",
    stars: 0,
    category: "tools-libraries",
    tags: ["Case Study", "Architecture", "Engineering", "Article"],
    featured: false,
  },
  {
    name: "openclaw-expert-agent",
    title: "OpenClaw Expert Agent (Wrench)",
    description: "Workspace de agente especializado para diagnóstico, auto-reparo e configuração de instalações do ecossistema OpenClaw.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/openclaw-expert-agent",
    language: "Markdown",
    stars: 0,
    category: "ai-agents",
    tags: ["Diagnostic Agent", "Self-Healing", "OpenClaw", "AI Agents"],
    featured: false,
  },
  {
    name: "dcb-office-proposal",
    title: "DCB Office Proposal Presentation",
    description: "Apresentação executiva interativa de proposta para escritórios e espaços corporativos da D&C Builders.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/dcb-office-proposal",
    language: "HTML",
    stars: 0,
    category: "web-saas",
    tags: ["Presentation", "Corporate", "Proposal", "HTML5"],
    featured: false,
  },
  {
    name: "nadeer-meeting-analysis",
    title: "Nadeer Meeting Analysis Engine",
    description: "Motor de processamento de linguagem natural para análise de transcrições e extração de requisitos contratuais.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/nadeer-meeting-analysis",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["NLP", "Requirements Extraction", "Python", "Analysis"],
    featured: false,
  },
  {
    name: "openclaw-office",
    title: "OpenClaw Office 3D Frontend",
    description: "Interface visual de monitoramento do sistema multi-agente OpenClaw: visualização de colaboração entre agentes em escritório digital.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/openclaw-office",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["Digital Office", "Multi-Agent Frontend", "WebSocket", "TypeScript"],
    featured: false,
  },
  {
    name: "dcb-proposal-generator",
    title: "DCB Proposal Generator",
    description: "Gerador de propostas comerciais em PDF de alta qualidade visual utilizando Python e WeasyPrint para a D&C Builders.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/dcb-proposal-generator",
    language: "Python",
    stars: 0,
    category: "tools-libraries",
    tags: ["WeasyPrint", "PDF Generation", "Python", "Document Automation"],
    featured: false,
  },
  {
    name: "recrutacis-hr-en",
    title: "RecrutaCIS HR International",
    description: "Versão internacional em inglês do dashboard corporativo de gestão de vagas, testes e candidatos do RecrutaCIS.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/recrutacis-hr-en",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["HR Tech", "Next.js", "Internationalization", "TypeScript"],
    featured: false,
  },
  {
    name: "recrutacis-candidate-dev",
    title: "RecrutaCIS Candidate Portal Dev",
    description: "Ambiente de desenvolvimento do portal do candidato para testes comportamentais e submissão de currículos com IA.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/recrutacis-candidate-dev",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Candidate Portal", "React", "HR Tech", "TypeScript"],
    featured: false,
  },
  {
    name: "recrutacis-hr-docker",
    title: "RecrutaCIS HR Containerized Deploy",
    description: "Configuração completa de container Docker e orquestração para deploy corporativo do módulo de RH do RecrutaCIS.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/recrutacis-hr-docker",
    language: "TypeScript",
    stars: 0,
    category: "infra-cloud",
    tags: ["Docker", "Deploy Ready", "Containerization", "TypeScript"],
    featured: false,
  },
  {
    name: "automatrix-webapp",
    title: "Automatrix WebApp HUB",
    description: "Portal central unificado para controle de automações, gestão de conexões de clientes e orquestração de IA da Automatrix.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/automatrix-webapp",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Automation Hub", "Web Platform", "Next.js", "TypeScript"],
    featured: false,
  },
  {
    name: "notebooklm-mcp",
    title: "NotebookLM MCP Server",
    description: "Servidor MCP para acesso programático e automação de fontes de conhecimento no Google NotebookLM.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/notebooklm-mcp",
    language: "Python",
    stars: 1,
    category: "ai-agents",
    tags: ["NotebookLM", "Google AI", "MCP", "Knowledge Graphs"],
    featured: false,
  },
  {
    name: "video-project-annalyzed",
    title: "Video Project Analyzer",
    description: "Extrator de dados de gestão de projetos a partir de reuniões em vídeo utilizando a API multimodal Gemini.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/video-project-annalyzed",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["Gemini API", "Video Understanding", "Project Management", "AI"],
    featured: false,
  },
  {
    name: "anytype-claude-skill",
    title: "Anytype Claude Skill",
    description: "Skill para agentes de IA gerenciarem bases de conhecimento Anytype de forma programática via MCP.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/anytype-claude-skill",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["Anytype", "Knowledge Base", "MCP", "Agent Skill"],
    featured: false,
  },
  {
    name: "whatsapp-to-notebooklm",
    title: "WhatsApp to NotebookLM Pipeline",
    description: "Pipeline automatizado para transcrever áudios do WhatsApp e estruturar conversas corporativas para o Google NotebookLM.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/whatsapp-to-notebooklm",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["NotebookLM", "WhatsApp Audio", "Transcription", "Python"],
    featured: false,
  },
  {
    name: "recrutacis-hr",
    title: "RecrutaCIS HR Dashboard",
    description: "Aplicação principal para times de RH gerenciarem processos seletivos, testes DISC e triagem curricular assistida por IA.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/recrutacis-hr",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Recruitment", "HR Dashboard", "AI Screening", "TypeScript"],
    featured: false,
  },
  {
    name: "Organograma-RCIS",
    title: "RecrutaCIS Organograma",
    description: "Visualizador interativo de estrutura organizacional e hierarquias corporativas integrado ao ecossistema RecrutaCIS.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/Organograma-RCIS",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Org Chart", "Data Visualization", "TypeScript", "React"],
    featured: false,
  },
  {
    name: "recrutacis-candidate-docker",
    title: "RecrutaCIS Candidate Container",
    description: "Imagem conteinerizada e pipelines de CI/CD para deploy escalável do portal de candidatos RecrutaCIS.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/recrutacis-candidate-docker",
    language: "TypeScript",
    stars: 0,
    category: "infra-cloud",
    tags: ["Docker", "Kubernetes", "DevOps", "TypeScript"],
    featured: false,
  },
  {
    name: "recrutacis-candidate",
    title: "RecrutaCIS Candidate Experience",
    description: "Portal voltado para candidatos realizarem inscrições, testes de perfil e acompanharem status em processos seletivos.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/recrutacis-candidate",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Candidate Experience", "Portal", "React", "TypeScript"],
    featured: false,
  },
  {
    name: "autoclip",
    title: "AutoClip Video Slicer",
    description: "Motor automatizado de corte de clipes virais a partir de podcasts e vídeos longos com detecção de ganchos por IA.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/autoclip",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["AI Video", "Auto Clipping", "Shorts", "FFmpeg"],
    featured: false,
  },
  {
    name: "rcisv1",
    title: "RecrutaCIS Legacy v1",
    description: "Primeira versão da arquitetura do RecrutaCIS com fluxos fundamentais de banco de talentos e avaliações.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/rcisv1",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["HR Tech", "Legacy", "Prototype", "Architecture"],
    featured: false,
  },
  {
    name: "agents",
    title: "Realtime Voice AI Agents Framework",
    description: "Framework de alta performance em Python para construção de agentes de voz em tempo real com baixa latência.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/agents",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["Voice AI", "Real-Time", "WebRTC", "Python"],
    featured: false,
  },
  {
    name: "lk-google-telnyx-1",
    title: "LiveKit Google Telnyx Voice Agent",
    description: "Agente telefônico inteligente integrando telefonia Telnyx, LiveKit e serviços de voz do Google Cloud.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/lk-google-telnyx-1",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["LiveKit", "Telnyx", "Telephony", "Voice Agent"],
    featured: false,
  },
  {
    name: "rcis-recruitment-platform",
    title: "RCIS Recruitment Platform",
    description: "Repositório mestre de serviços corporativos para o sistema de recrutamento com gestão de ponta a ponta.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/rcis-recruitment-platform",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Recruitment", "Talent Pool", "Fullstack", "TypeScript"],
    featured: false,
  },
  {
    name: "n8n",
    title: "n8n Workflow Automation Platform",
    description: "Fork e configurações avançadas da plataforma n8n com nós customizados de IA e automação empresarial.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/n8n",
    language: "TypeScript",
    stars: 0,
    category: "automation-crm",
    tags: ["n8n", "Workflow Engine", "Integration", "TypeScript"],
    featured: false,
  },
  {
    name: "newRCIS",
    title: "RecrutaCIS AI Resume Analysis",
    description: "Módulo aprimorado para parsing e análise semântica de currículos com pontuação de aderência a vagas.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/newRCIS",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Resume Parser", "Semantic Search", "HR Tech", "AI"],
    featured: false,
  },
  {
    name: "Video-Frame-Extraction-Utility",
    title: "Video Frame Extraction Utility",
    description: "Utilitário em Python e Jupyter Notebook com OpenCV para extração amostral de frames de vídeo de alta resolução.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/Video-Frame-Extraction-Utility",
    language: "Python",
    stars: 0,
    category: "tools-libraries",
    tags: ["OpenCV", "Frame Extraction", "Computer Vision", "Jupyter"],
    featured: false,
  },
  {
    name: "whatsapp-mcp",
    title: "WhatsApp MCP Server",
    description: "Servidor Model Context Protocol (MCP) em Go para integração nativa de agentes de IA com mensageria WhatsApp.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/whatsapp-mcp",
    language: "Go",
    stars: 0,
    category: "ai-agents",
    tags: ["MCP", "Go", "WhatsApp", "AI Tools"],
    featured: false,
  },
  {
    name: "rhrcis",
    title: "RH RecrutaCIS Portal",
    description: "Painel de recursos humanos focado na condução de dinâmicas e relatórios analíticos de candidatos.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/rhrcis",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["HR Dashboard", "Analytics", "Talent Acquisition", "TypeScript"],
    featured: false,
  },
  {
    name: "DreamBoard",
    title: "DreamBoard Visual Creator",
    description: "Aplicação interativa para montagem e geração de quadros de metas e visualização de objetivos pessoais.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/DreamBoard",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Canvas", "Goals", "Interactive UI", "TypeScript"],
    featured: false,
  },
  {
    name: "mind-insurance-app",
    title: "Mind Insurance App",
    description: "Plataforma de coaching executivo e transformação de identidade Purposewaze com metodologia PROTECT.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/mind-insurance-app",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Coaching", "Mental Health", "React", "TypeScript"],
    featured: false,
  },
  {
    name: "CopilotKit",
    title: "CopilotKit Infrastructure",
    description: "Infraestrutura elegante para integração de copilotos de IA, chatbots contextuais e agentes in-app no ecossistema React.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/CopilotKit",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["CopilotKit", "React UI", "AI Copilot", "TypeScript"],
    featured: false,
  },
  {
    name: "ag-ui",
    title: "AG-UI Interaction Protocol",
    description: "Protocolo de interação agente-usuário para integração fluida de agentes de IA em interfaces frontend modernas.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/ag-ui",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["Agent Protocol", "UI Components", "Copilot", "TypeScript"],
    featured: false,
  },
  {
    name: "protekt-daily",
    title: "Protekt Daily Tracker",
    description: "Painel de acompanhamento diário de práticas e métricas de foco da metodologia comportamental PROTECT.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/protekt-daily",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Habits", "Daily Tracker", "HealthTech", "TypeScript"],
    featured: false,
  },
  {
    name: "mind-insurance-challenge-app",
    title: "Mind Insurance Challenge Mobile",
    description: "Aplicativo React Native/Expo focado na execução de desafios diários e alinhamento de propósito pessoal.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/mind-insurance-challenge-app",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["React Native", "Expo", "Mobile App", "TypeScript"],
    featured: false,
  },
  {
    name: "identitymaker",
    title: "IdentityMaker Assessment Platform",
    description: "Plataforma de criação de formulários inteligentes e avaliação psicológica de colisões de identidade assistida por IA.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/identitymaker",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Assessment", "Form Builder", "AI Evaluation", "TypeScript"],
    featured: false,
  },
  {
    name: "glow-nav-nexus",
    title: "Glow Nav Nexus",
    description: "Componente experimental de navegação dinâmica com iluminação responsiva e efeitos visuais em CSS/WebGL.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/glow-nav-nexus",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["UI Components", "Animation", "Frontend", "TypeScript"],
    featured: false,
  },
  {
    name: "identity-shift-forms",
    title: "Identity Shift Form Creator",
    description: "Gerador de formulários adaptativos e questionários psicológicos com pontuação dinâmica e feedback imediato.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/identity-shift-forms",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Dynamic Forms", "Psychometrics", "TypeScript", "React"],
    featured: false,
  },
  {
    name: "bytebot",
    title: "Bytebot Desktop AI Agent",
    description: "Agente de IA self-hosted capaz de interagir e automatizar tarefas no desktop Linux via comandos em linguagem natural.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/bytebot",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["Computer Use", "Desktop Agent", "Automation", "TypeScript"],
    featured: false,
  },
  {
    name: "postiz-app",
    title: "Postiz Social Media Scheduler",
    description: "Plataforma open-source completa de agendamento e gerenciamento de publicações em redes sociais com recursos de IA.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/postiz-app",
    language: "TypeScript",
    stars: 0,
    category: "automation-crm",
    tags: ["Social Media", "Scheduling", "Marketing Automation", "TypeScript"],
    featured: false,
  },
  {
    name: "formulario-facil-br",
    title: "Formulário Fácil BR",
    description: "Construtor visual de formulários rápidos e acessíveis voltado para o mercado e validações brasileiras.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/formulario-facil-br",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Form Builder", "Brazil Forms", "Validation", "TypeScript"],
    featured: false,
  },
  {
    name: "task-card-shine-39",
    title: "Task Card Interactive Showcase",
    description: "Interface moderna de gestão de cartões de tarefas com microinterações fluidas e estética dark futurista.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/task-card-shine-39",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Kanban", "Micro-Interactions", "UI Design", "TypeScript"],
    featured: false,
  },
  {
    name: "short-video-makerMCP",
    title: "Short Video Maker MCP",
    description: "Servidor MCP e API REST para orquestração da geração programática de vídeos curtos com modelos de IA.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/short-video-makerMCP",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["MCP", "Video AI", "REST API", "TypeScript"],
    featured: false,
  },
  {
    name: "ShortGPT",
    title: "ShortGPT Experimental AI Framework",
    description: "Framework experimental de automação completa para criação de canais automatizados no YouTube Shorts e TikTok.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/ShortGPT",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["ShortGPT", "Video Automation", "Generative AI", "Python"],
    featured: false,
  },
  {
    name: "short-video-maker",
    title: "Short Video Maker AI",
    description: "Pipeline automatizado em Python para criação de vídeos verticais (TikTok, Shorts, Reels) com narração e legendas.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/short-video-maker",
    language: "Python",
    stars: 0,
    category: "ai-agents",
    tags: ["Shorts", "Video Generation", "Python", "Automation"],
    featured: false,
  },
  {
    name: "instaloader",
    title: "Instaloader Automation Utility",
    description: "Ferramenta para download e indexação de mídias, legendas e metadados de contas públicas do Instagram.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/instaloader",
    language: "Python",
    stars: 0,
    category: "automation-crm",
    tags: ["Instagram", "Media Pipeline", "Python", "Data Extraction"],
    featured: false,
  },
  {
    name: "vibe-kanban",
    title: "Vibe Kanban Agent Manager",
    description: "Quadro Kanban de alto desempenho em Rust para acompanhamento e controle de agentes de desenvolvimento autônomos.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/vibe-kanban",
    language: "Rust",
    stars: 0,
    category: "ai-agents",
    tags: ["Rust", "Kanban", "AI Agents Management", "CLI"],
    featured: false,
  },
  {
    name: "evo-ai",
    title: "Evo AI Multi-Agent Platform",
    description: "Plataforma open-source para criação, orquestração e gerenciamento de agentes autônomos integrados a múltiplos LLMs.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/evo-ai",
    language: "TypeScript",
    stars: 0,
    category: "ai-agents",
    tags: ["Multi-Agent", "Open-Source", "LLMs", "TypeScript"],
    featured: false,
  },
  {
    name: "info-shape-shifter",
    title: "Info Shape Shifter",
    description: "Componente interativo para transformação dinâmica e transição fluida de estruturas de informação em interfaces web.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/info-shape-shifter",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Data Viz", "UI Components", "Motion", "TypeScript"],
    featured: false,
  },
  {
    name: "node-flow-sketcher",
    title: "Node Flow Sketcher",
    description: "Editor visual baseado em nós para prototipagem de grafos lógicos, automações e fluxogramas operacionais.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/node-flow-sketcher",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Node Graph", "Visual Programming", "React Flow", "TypeScript"],
    featured: false,
  },
  {
    name: "coding-adventure-world",
    title: "Coding Adventure World",
    description: "Experiência gamificada interativa para aprendizado de lógica de programação e algoritmos no navegador.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/coding-adventure-world",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Gamification", "EdTech", "Canvas", "TypeScript"],
    featured: false,
  },
  {
    name: "ImageGridFlow",
    title: "Image Grid Flow",
    description: "Layout responsivo de alta performance para exibição de galerias infinitas de imagens com ordenação fluida.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/ImageGridFlow",
    language: "JavaScript",
    stars: 0,
    category: "tools-libraries",
    tags: ["Image Gallery", "Masonry", "Frontend", "JavaScript"],
    featured: false,
  },
  {
    name: "appdavisao",
    title: "App da Visão Computacional",
    description: "Interface web experimental para testes de modelos de detecção de objetos e visão computacional no navegador.",
    isPrivate: false,
    url: "https://github.com/Morfeu333/appdavisao",
    language: "JavaScript",
    stars: 0,
    category: "ai-agents",
    tags: ["Computer Vision", "Object Detection", "AI", "Web"],
    featured: false,
  },
  {
    name: "simple-web-duplicate",
    title: "Simple Web Cloner",
    description: "Utilitário para análise e reprodução de componentes visuais e layouts web com estética preservada.",
    isPrivate: true,
    url: "https://github.com/Morfeu333/simple-web-duplicate",
    language: "TypeScript",
    stars: 0,
    category: "web-saas",
    tags: ["Layouts", "Cloning", "Frontend", "TypeScript"],
    featured: false,
  },
];

export const GITHUB_CATEGORIES: { id: RepoCategory; label: string; count: number; description: string }[] = [
  {
    id: "ai-agents",
    label: "Agentes & Inteligência Artificial",
    count: 43,
    description: "Agentes autônomos, LLMs, MCPs, Engenharia de Prompt, Visão Computacional e IA",
  },
  {
    id: "automation-crm",
    label: "Automação & CRM",
    count: 33,
    description: "GoHighLevel, n8n, Chatwoot, Meta Cloud API, WhatsApp e automações comerciais",
  },
  {
    id: "web-saas",
    label: "Aplicações Web & SaaS",
    count: 51,
    description: "Aplicações web modernas (React, Next.js, Vite, Three.js, dashboards e landing pages)",
  },
  {
    id: "infra-cloud",
    label: "Infraestrutura & Cloud",
    count: 15,
    description: "Cloudflare Workers/Pages, VPS, Docker, Linux, scripts de build e infraestrutura",
  },
  {
    id: "tools-libraries",
    label: "Ferramentas & Utilitários",
    count: 26,
    description: "Ferramentas, bibliotecas de mídia, extensões e utilitários de produtividade",
  },
];
